import { render } from "./PublicNewConvert.vue?vue&type=template&id=9fefd030&scoped=true"
import script from "./PublicNewConvert.vue?vue&type=script&lang=js"
export * from "./PublicNewConvert.vue?vue&type=script&lang=js"

import "./PublicNewConvert.vue?vue&type=style&index=0&id=9fefd030&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fefd030"]])

export default __exports__